export default {"src":"/_next/static/media/Mouthwave.997d7055.svg","height":33,"width":51,"blurWidth":0,"blurHeight":0};